import { render, staticRenderFns } from "./IconClass.vue?vue&type=template&id=8d1eb9b8"
import script from "./IconClass.vue?vue&type=script&lang=js"
export * from "./IconClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports